// extracted by mini-css-extract-plugin
module.exports = {"posCard":"styles-module--posCard--2LDH3","title":"styles-module--title--3T-lp","logo":"styles-module--logo--3Vapt","impactList":"styles-module--impactList--1MI6z"};